<script setup lang="ts">
const paginationContext = usePaginationContext();

defineProps<{
  ariaLabel?: string;
}>();
</script>

<template>
  <PaginationButton
    :disabled="paginationContext.isFirstDisabled.value"
    :aria-label="ariaLabel ?? $t('Pagination.Aria.FirstPageButton')"
    :on-click="paginationContext.firstPage"
  >
    <BaseIcon
      name="first"
      prefix="pagination"
    />
  </PaginationButton>
</template>
